// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ix5Ti","documentContainer":"styles_documentContainer__2AoIM"};